<template>
    <div class="layout">
        <Layout class="layout-inner">
            <!-- top header -->
            <Header class="layout-header">
                <Row type="flex" justify="space-between">
                    <div class="toggle-menu" @click="toggleClick">
                        <Icon type="ios-medical-outline" size="22" color="#fff"></Icon>
                    </div>
                    <Dropdown trigger="click" class="sign-out" @on-click="signOut">
                        <a href="javascript:void(0)">
                            <i class="user-icon"></i>
                            {{ userInfo.supplierNo }}
                        </a>
                        <DropdownMenu slot="list">
                            <DropdownItem>退出</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </Row>
            </Header>
            <!-- sidebar nav -->
            <Layout class="layout-content">
                <Sider hide-trigger :style="{background: '#fff'}" class="layout-siders" :class="{'side-padding': isCollapsed}">
                    <Menu :active-name="activeName" theme="light" width="auto" @on-select="onSelect">
                        <menu-item v-for="(menu, index) in menus" :key="index" :name="menu.path" :to="menu.path">
                            <span>{{ menu.name }}</span>
                        </menu-item>
                    </Menu>
                </Sider>
                <Layout class="layout-child-view" :class="{'con-padding': isCollapsed}">
                    <Content class="layout-cont">
                        <router-view/>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
        <Modal
            class="model-postion-tip model-postion-setting"
            v-model="tipModel"
            :mask-closable="false"
            title="公告">
            <div class="history-order">
                <p class="text-title">尊敬的客户：</p>
                <p class="text-space">感谢您长期使用供应商共享系统。为持续提供更稳定、高效的服务与技术支持，系统将于近期启动可持续运营模式。</p>
                <p class="text-space">您的账户将于7日后暂停使用。如需继续使用，请务必在此前拨打服务热线<span>15929427783</span>完成服务确认。</p>
                <p class="text-space">由此给您带来的不便，我们深表歉意。我们期待继续为您提供有价值的服务。</p>
            </div>
            <template slot="footer">
                <span class="his-ok" @click="tipModel = false">关闭</span>
            </template>
        </Modal>
    </div>
</template>

<script>
import menus from '@/menus/menus.js';
import Cookies from 'js-cookie';

import { getOrganList } from '@/graphql/query.js';
export default {
    data() {
        return {
            isCollapsed: false,
            menus: menus,
            userInfo: Cookies.getJSON('USER-INFO') || '',
            activeName: '/index/receiptsList',
            tipModel: false
        };
    },
    mounted() {
        const level = Cookies.getJSON('USER-INFO').level;
        if ((level === 'A' || level === 'B' || level === 'C') && !sessionStorage.getItem('initialized')) {
            this.performOneTimeInitialization();
            sessionStorage.setItem('initialized', 'true');
        }
        const supplierNo = Cookies.getJSON('supplierNo');
        const supplierFun = JSON.parse(window.localStorage.getItem('supplierFunction'));
        const paths = [
            '/index/plan',
            '/index/review',
            '/index/supplier',
            '/index/metarials',
            '/index/materials-price',
            '/index/plan_price',
            '/index/materials-independ'
        ];
        let filteredArray = this.menus.filter(item => !paths.includes(item.path));
        this.menus = filteredArray;
        if (supplierNo === 'sadmin') {
            this.menus.push({
                name: '新物资审核',
                path: '/index/review'
            }, {
                name: '供应商管理',
                path: '/index/supplier'
            }, {
                name: '物资管理',
                path: '/index/metarials'
            });
        }
        if (supplierFun.project1 > -1) {
            this.menus.push({
                name: '计划管理',
                path: '/index/plan_price'
            });
        }
        if (supplierFun.quotation > -1) {
            this.menus.push({
                name: '询价单管理',
                path: '/index/materials-price'
            });
        }
        if (supplierNo === '1003sadmin' && supplierFun.productControl > -1) {
            this.menus.push({
                name: '物资库',
                path: '/index/materials-independ'
            });
        }
        if (window.localStorage.getItem('activeName')) {
            this.activeName = window.localStorage.getItem('activeName');
        }
        this.getOragans();
    },

    beforeDestroy() {
        this.$store.commit('checkOrgans', []);
    },

    methods: {
        toggleClick() {
            this.isCollapsed = !this.isCollapsed;
        },
        performOneTimeInitialization() {
            this.tipModel = true;
        },
        onSelect(name) {
            this.activeName = name;
            window.localStorage.setItem('activeName', name);
        },
        // 退出
        signOut() {
            Cookies.remove('cliqueNo');
            Cookies.remove('USER-INFO');
            Cookies.remove('token');
            Cookies.remove('supplierNo');
            window.sessionStorage.clear();
            window.localStorage.clear();
            this.$router.push('/');
        },

        async getOragans() {
            let list = await getOrganList(this);
            this.$store.commit('checkOrgans', list);
        }
    }
};
</script>

<style scoped lang="stylus">

.layout
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;

    .layout-inner
        min-height: 100vh;

        .layout-header
            position: fixed;
            width: 100%;
            z-index: 999;

        .layout-content
            margin: 64px 0 0;
            background: #fff;

            .layout-siders
                position: fixed;
                height: 100%;
                width: 150px;
                z-index: 200;
            .side-padding
                display: none

        .sign-out
            color: #fff;
            font-size: 16px;
            a
                color: #ddd;

            .user-icon
                display: inline-block;
                width: 20px;
                height: 20px;
                background: url(../assets/images/user.png) no-repeat center center/contain;
                vertical-align: sub;
                margin-right: 4px;

    .layout-logo
        width: 100px;
        height: 30px;
        background: #5b6270;
        border-radius: 3px;
        float: left;
        position: relative;
        top: 15px;
        left: 20px;

    .layout-nav
        width: 420px;
        margin: 0 auto;
        margin-right: 20px;

    .layout-child-view
        padding: 24px;
        .layout-cont
            position: relative;
            padding: 24px;
            min-height: 280px;
            background: #fff;
            margin-left: 200px;
    .con-padding
        padding: 0
        .layout-cont
            margin-left: 0

.history-order
    font-size: 14px;
    padding: 0 11px;
    .text-title
        padding-bottom: 4px;
    .text-space
        text-indent: 26px;
        line-height: 26px;
        span
            color: #2d8cf0;
            text-indent: 0;
            font-size: 16px;
            display: inline-block;
</style>



// WEBPACK FOOTER //
// src/layout/Layout.vue